var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileCartInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.04715 0.502121L6.55175 12.5766H15.1635C17.1717 12.5766 18.985 11.3751 19.7679 9.52578L21.1311 6.30556C21.4102 5.6462 20.9262 4.91572 20.2102 4.91572H4.28507",
    stroke: "#404554"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0471497 0.502121H1.54511C2.43496 0.502121 3.21779 1.09004 3.46584 1.94463L6.55175 12.5766H15.1635C17.1717 12.5766 18.985 11.3751 19.7679 9.52578L21.1311 6.30556C21.4102 5.6462 20.9262 4.91572 20.2102 4.91572H4.28507",
    stroke: "#404554"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.45799 21.5803C9.56256 21.5803 10.458 20.6849 10.458 19.5803C10.458 18.4757 9.56256 17.5803 8.45799 17.5803C7.35342 17.5803 6.45799 18.4757 6.45799 19.5803C6.45799 20.6849 7.35342 21.5803 8.45799 21.5803Z",
    stroke: "#404554"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3065 15.8099H8.94412C8.03547 15.8099 7.24101 15.1973 7.00989 14.3186L6.55175 12.5766L13.9095 12.5766",
    stroke: "#404554"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9403 21.5803C18.0449 21.5803 18.9403 20.6849 18.9403 19.5803C18.9403 18.4757 18.0449 17.5803 16.9403 17.5803C15.8358 17.5803 14.9403 18.4757 14.9403 19.5803C14.9403 20.6849 15.8358 21.5803 16.9403 21.5803Z",
    stroke: "#404554"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileCartInactive);
export default __webpack_public_path__ + "static/media/MobileCartInactive.127959b8.svg";
export { ForwardRef as ReactComponent };